import React, { useState, useEffect, useRef } from 'react';
import { supabase } from '../supabase';
import logo from '../logo.png'; 
import { Helmet } from 'react-helmet-async'; 

// --- YENİ NESİL AKILLI SIKIŞTIRMA VE BOYUTLANDIRMA MOTORU ---
const convertToWebP = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        
        // SİHİRLİ KOD: Devasa resimleri kaliteyi bozmadan boyutlandırır
        const MAX_WIDTH = 1000;
        const MAX_HEIGHT = 1000;
        let width = img.width;
        let height = img.height;

        // En-boy oranını (aspect ratio) koruyarak resmi küçültür
        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        
        // Arka planı beyaz yap (Eğer transparan bir PNG yüklenirse arkası siyah olmasın diye)
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        ctx.drawImage(img, 0, 0, width, height);
        
        // Quality (Kalite) oranını 0.8'den 0.7'ye çektik, gözle fark edilmez ama siteyi uçurur!
        canvas.toBlob((blob) => {
          if (!blob) { reject(new Error('Canvas boş kaldı')); return; }
          const yeniIsim = file.name.replace(/\.[^/.]+$/, "") + ".webp";
          const webpFile = new File([blob], yeniIsim, { type: 'image/webp' });
          resolve(webpFile);
        }, 'image/webp', 0.7);
      };
      img.onerror = (error) => reject(error);
    };
    reader.onerror = (error) => reject(error);
  });
};

function Admin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); 
  
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [activeTab, setActiveTab] = useState('urunler');
  const [altSekme, setAltSekme] = useState('ekle'); 
  const [uploading, setUploading] = useState(false);
  // --- KURTARMA OPERASYONU STATE'İ ---
  const [operasyonDurumu, setOperasyonDurumu] = useState('');
  const [operasyonCalisiyor, setOperasyonCalisiyor] = useState(false);
  
  const [mevcutKameralar, setMevcutKameralar] = useState([]);
  const [mevcutUrunler, setMevcutUrunler] = useState([]);
  const [mevcutProjeler, setMevcutProjeler] = useState([]);

  const [aramaMetni, setAramaMetni] = useState('');
  const [silmeSayfasi, setSilmeSayfasi] = useState(1);
  const sayfaBasinaOge = 24;

  const [kameraBaslik, setKameraBaslik] = useState('');
  const [kameraAciklama, setKameraAciklama] = useState('');
  const [kameraOzellikler, setKameraOzellikler] = useState('');
  const [kameraResimleri, setKameraResimleri] = useState([]); 

  const [projeAdi, setProjeAdi] = useState('');
  const [resimDosyalari, setResimDosyalari] = useState([]);

  const [urunBaslik, setUrunBaslik] = useState('');
  const [urunKategori, setUrunKategori] = useState('Güvenlik Fileleri');
  const [urunAciklama, setUrunAciklama] = useState('');
  const [urunOzellikler, setUrunOzellikler] = useState('');
  const [urunResimleri, setUrunResimleri] = useState([]);

  const timerRef = useRef(null);
  const OTO_CIKIS_SURESI = 15 * 60 * 1000; 

  const handleLogout = async () => { 
    await supabase.auth.signOut(); 
    setSession(null);
  };

  // =========================================================
  // --- SİHİRLİ KOD: TOPLU ESKİ RESİM OPTİMİZASYON MOTORU ---
  // =========================================================
  const topluResimOptimizeEt = async () => {
    const onay = window.confirm("DİKKAT: Bu işlem sitedeki tüm eski/büyük resimleri bulup sıkıştıracaktır. İşlem bitene kadar sekmeyi KAPATMAYIN. Başlayalım mı?");
    if (!onay) return;

    setOperasyonCalisiyor(true);
    setOperasyonDurumu('Operasyon başladı. Veritabanı taranıyor...');

    try {
      // 1. Şimdilik 'projeler' tablosunu yapalım (İstersen urunler ve kameralar için de aynı bloğu kopyalayabilirsin)
      const { data: projeler } = await supabase.from('projeler').select('*');
      
      let islenenSayi = 0;

      for (let proje of projeler) {
        // Eğer resim zaten .webp uzantılıysa atla (zaten optimize edilmiştir)
        if (proje.resim_url && !proje.resim_url.includes('.webp')) {
          setOperasyonDurumu(`İşleniyor: ${proje.proje_adi} (${islenenSayi + 1} / ${projeler.length})`);
          
          try {
            // A. Eski büyük resmi URL'den Blob (dosya) olarak indir
            const response = await fetch(proje.resim_url);
            const blob = await response.blob();
            // Dosyayı sistemin anlayacağı File objesine çevir
            const eskiDosya = new File([blob], `eski_${proje.id}.jpg`, { type: blob.type });

            // B. Bizim yazdığımız o efsane motorla küçült ve WebP yap
            const webpDosya = await convertToWebP(eskiDosya);

            // C. Yeni, küçücük resmi Supabase'e yükle
            const rastgeleIsim = `opt_${Math.random()}.webp`;
            const { error: uploadError } = await supabase.storage.from('medya').upload(`projeler/${rastgeleIsim}`, webpDosya);
            if (uploadError) throw uploadError;

            // D. Yeni resmin linkini al
            const { data: { publicUrl } } = supabase.storage.from('medya').getPublicUrl(`projeler/${rastgeleIsim}`);

            // E. Veritabanındaki eski linki yeni linkle güncelle
            await supabase.from('projeler').update({ resim_url: publicUrl }).eq('id', proje.id);

            // F. Eski devasa resmi Supabase Storage'dan silip yer aç
            const eskiYol = proje.resim_url.split('/medya/')[1];
            if (eskiYol) {
              await supabase.storage.from('medya').remove([eskiYol]);
            }
            
            islenenSayi++;
          } catch (err) {
            console.error(`${proje.proje_adi} optimize edilirken hata:`, err);
          }
        }
      }

      setOperasyonDurumu(`Tebrikler! Toplam ${islenenSayi} adet devasa resim başarıyla küçültüldü ve değiştirildi. 🎉`);
    } catch (error) {
      setOperasyonDurumu(`Hata oluştu: ${error.message}`);
    } finally {
      setOperasyonCalisiyor(false);
    }
  };

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      handleLogout();
      alert("🔒 Güvenlik nedeniyle oturumunuz zaman aşımına uğradı. Lütfen tekrar giriş yapın.");
    }, OTO_CIKIS_SURESI);
  };

  useEffect(() => {
    if (session) {
      resetTimer(); 
      window.addEventListener('mousemove', resetTimer);
      window.addEventListener('keydown', resetTimer);
      window.addEventListener('click', resetTimer);
      window.addEventListener('scroll', resetTimer);
    }
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keydown', resetTimer);
      window.removeEventListener('click', resetTimer);
      window.removeEventListener('scroll', resetTimer);
    };
  }, [session]);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => setSession(session));
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => setSession(session));
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    setAramaMetni('');
    setSilmeSayfasi(1);
    if(altSekme !== 'liste') setAltSekme('ekle');
  }, [activeTab, altSekme]);

  useEffect(() => {
    if (!session || altSekme !== 'liste') return; 
    const verileriGetir = async () => {
      if (activeTab === 'kameralar') {
        const { data } = await supabase.from('kameralar').select('*').order('olusturulma_tarihi', { ascending: false });
        if(data) setMevcutKameralar(data);
      } else if (activeTab === 'urunler') {
        const { data } = await supabase.from('urunler').select('*').order('olusturulma_tarihi', { ascending: false });
        if(data) setMevcutUrunler(data);
      } else if (activeTab === 'projeler') {
        const { data } = await supabase.from('projeler').select('*').order('olusturulma_tarihi', { ascending: false });
        if(data) setMevcutProjeler(data);
      }
    };
    verileriGetir();
  }, [activeTab, altSekme, session]);

  const getGosterilecekVeri = (veriListesi) => {
    const filtrelenmis = veriListesi.filter(item => {
      const ad = item.baslik || item.proje_adi || '';
      return ad.toLowerCase().includes(aramaMetni.toLowerCase());
    });
    const toplamSayfa = Math.ceil(filtrelenmis.length / sayfaBasinaOge);
    const sonIndex = silmeSayfasi * sayfaBasinaOge;
    const ilkIndex = sonIndex - sayfaBasinaOge;
    const sayfaVerisi = filtrelenmis.slice(ilkIndex, sonIndex);
    return { sayfaVerisi, toplamSayfa, toplamOgeSayisi: filtrelenmis.length };
  };

  let gecerliListe = [];
  if (activeTab === 'kameralar') gecerliListe = mevcutKameralar;
  if (activeTab === 'urunler') gecerliListe = mevcutUrunler;
  if (activeTab === 'projeler') gecerliListe = mevcutProjeler;
  
  const { sayfaVerisi, toplamSayfa, toplamOgeSayisi } = getGosterilecekVeri(gecerliListe);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError("Giriş başarısız. Lütfen bilgilerinizi kontrol edin dostum.");
    setLoading(false);
  };

  const handleSil = async (tablo, id, resimListesi) => {
    const onay = window.confirm("Bu öğeyi tamamen silmek istediğine emin misin? Bu işlem geri alınamaz!");
    if (!onay) return;
    try {
      if (resimListesi && resimListesi.length > 0) {
        const silinecekYollar = resimListesi.map(url => {
          const urlParcalari = url.split('/medya/');
          return urlParcalari.length > 1 ? urlParcalari[1] : null;
        }).filter(yol => yol !== null);
        if (silinecekYollar.length > 0) await supabase.storage.from('medya').remove(silinecekYollar);
      }
      const { error } = await supabase.from(tablo).delete().eq('id', id);
      if (error) throw error;
      if (tablo === 'kameralar') setMevcutKameralar(prev => prev.filter(item => item.id !== id));
      if (tablo === 'urunler') setMevcutUrunler(prev => prev.filter(item => item.id !== id));
      if (tablo === 'projeler') setMevcutProjeler(prev => prev.filter(item => item.id !== id));
      alert('Öğe sistemden silindi!');
    } catch (error) { alert("Silinirken bir hata oluştu: " + error.message); }
  };

  const handleKameraEkle = async (e) => {
    e.preventDefault();
    if (!kameraBaslik || kameraResimleri.length === 0) { alert('Başlık ve resim zorunludur!'); return; }
    setUploading(true);
    try {
      const uploadPromises = kameraResimleri.map(async (dosya) => {
        const webpDosya = await convertToWebP(dosya);
        const rastgeleIsim = `${Math.random()}.webp`; 
        const { error } = await supabase.storage.from('medya').upload(`kameralar/${rastgeleIsim}`, webpDosya);
        if (error) throw error;
        const { data } = supabase.storage.from('medya').getPublicUrl(`kameralar/${rastgeleIsim}`);
        return data.publicUrl;
      });
      const urlList = await Promise.all(uploadPromises);
      const { error: dbError } = await supabase.from('kameralar').insert([{ baslik: kameraBaslik, aciklama: kameraAciklama, ozellikler: kameraOzellikler, resimler: urlList }]);
      if (dbError) throw dbError;
      alert(`Kamera eklendi!`);
      setKameraBaslik(''); setKameraAciklama(''); setKameraOzellikler(''); setKameraResimleri([]); 
    } catch (error) { alert('Hata: ' + error.message); } finally { setUploading(false); }
  };

  const handleProjeEkle = async (e) => {
    e.preventDefault();
    if (resimDosyalari.length === 0 || !projeAdi) { alert('Proje adı ve resim zorunludur!'); return; }
    setUploading(true);
    try {
      const uploadPromises = resimDosyalari.map(async (dosya) => {
        const webpDosya = await convertToWebP(dosya);
        const rastgeleIsim = `${Math.random()}.webp`; 
        const { error } = await supabase.storage.from('medya').upload(`projeler/${rastgeleIsim}`, webpDosya);
        if (error) throw error;
        const { data } = supabase.storage.from('medya').getPublicUrl(`projeler/${rastgeleIsim}`);
        const { error: dbError } = await supabase.from('projeler').insert([{ proje_adi: projeAdi, resim_url: data.publicUrl }]);
        if (dbError) throw dbError;
      });
      await Promise.all(uploadPromises);
      alert(`Proje eklendi!`);
      setProjeAdi(''); setResimDosyalari([]); 
    } catch (error) { alert('Hata: ' + error.message); } finally { setUploading(false); }
  };

  const handleUrunEkle = async (e) => {
    e.preventDefault();
    if (!urunBaslik || urunResimleri.length === 0) { alert('Ürün başlığı ve resim zorunludur!'); return; }
    setUploading(true);
    try {
      const uploadPromises = urunResimleri.map(async (dosya) => {
        const webpDosya = await convertToWebP(dosya);
        const rastgeleIsim = `${Math.random()}.webp`; 
        const { error } = await supabase.storage.from('medya').upload(`urunler/${rastgeleIsim}`, webpDosya);
        if (error) throw error;
        const { data } = supabase.storage.from('medya').getPublicUrl(`urunler/${rastgeleIsim}`);
        return data.publicUrl;
      });
      const urlList = await Promise.all(uploadPromises);
      const { error: dbError } = await supabase.from('urunler').insert([{ baslik: urunBaslik, kategori: urunKategori, aciklama: urunAciklama, ozellikler: urunOzellikler, resimler: urlList }]);
      if (dbError) throw dbError;
      alert(`Ürün eklendi!`);
      setUrunBaslik(''); setUrunAciklama(''); setUrunOzellikler(''); setUrunResimleri([]);
    } catch (error) { alert('Hata: ' + error.message); } finally { setUploading(false); }
  };

  // --- EFSANEVİ AKILLI SAYFALAMA MOTORU ---
  const getSayfaNumaralari = (mevcut, toplam) => {
    const delta = 1; 
    const range = [];
    for (let i = Math.max(2, mevcut - delta); i <= Math.min(toplam - 1, mevcut + delta); i++) {
      range.push(i);
    }
    if (mevcut - delta > 2) range.unshift("...");
    if (mevcut + delta < toplam - 1) range.push("...");
    range.unshift(1);
    if (toplam > 1) range.push(toplam);
    return range;
  };

  if (!session) {
    return (
      <div className="admin-login-container">
        <Helmet><title>Güvenli Yönetim Paneli | Demir Grup</title></Helmet>
        <div className="admin-login-box">
          <img src={logo} alt="Demir Grup" className="admin-logo" />
          <h2>Yönetici Paneli</h2>
          {error && <div className="error-message">{error}</div>}
          <form onSubmit={handleLogin}>
            <input type="email" placeholder="E-posta" value={email} onChange={(e) => setEmail(e.target.value)} required />
            
            <div className="password-wrapper">
              <input 
                type={showPassword ? "text" : "password"} 
                placeholder="Şifre" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                required 
              />
              <button 
                type="button" 
                className="eye-btn" 
                onClick={() => setShowPassword(!showPassword)}
                title={showPassword ? "Şifreyi Gizle" : "Şifreyi Göster"}
              >
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>

            <button type="submit" disabled={loading} className="admin-btn">Giriş Yap ↗</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-dashboard-wrapper">
      <Helmet><title>Kokpit | Demir Grup Yönetim</title></Helmet>
      
      <div className="admin-sidebar">
        <img src={logo} alt="Demir Grup" className="admin-logo-small" />
        <ul className="admin-menu">
          <li className={activeTab === 'kameralar' ? 'active' : ''} onClick={() => setActiveTab('kameralar')}>Kameralar</li>
          <li className={activeTab === 'urunler' ? 'active' : ''} onClick={() => setActiveTab('urunler')}>Ürünler</li>
          <li className={activeTab === 'projeler' ? 'active' : ''} onClick={() => setActiveTab('projeler')}>Projeler</li>
        </ul>
        <button onClick={handleLogout} className="logout-btn">Çıkış Yap 🚪</button>
      </div>

      <div className="admin-content">
        <div className="admin-header">
          <h2>Yönetim Kokpiti</h2>
        </div>
        
        <div className="admin-panel-card">
          
          <div className="admin-sub-tabs">
            <button className={altSekme === 'ekle' ? 'active' : ''} onClick={() => setAltSekme('ekle')}>➕ Yeni Ekle</button>
            <button className={altSekme === 'liste' ? 'active' : ''} onClick={() => setAltSekme('liste')}>🗑️ Mevcutları Sil</button>
          </div>

          {altSekme === 'liste' && (
            <div className="admin-list-section">
              <div className="admin-search-bar">
                <input 
                  type="text" 
                  placeholder="🔍 Aranacak öğenin adını yazın..." 
                  value={aramaMetni} 
                  onChange={(e) => {
                    setAramaMetni(e.target.value);
                    setSilmeSayfasi(1);
                  }} 
                  className="admin-form-input search-input" 
                />
              </div>

              {toplamOgeSayisi === 0 ? (
                <p style={{color: '#94a3b8', textAlign: 'center', padding: '20px'}}>Bu kriterlere uygun öğe bulunamadı.</p>
              ) : (
                <>
                  <div className="admin-list-grid">
                    {sayfaVerisi.map(item => (
                      <div key={item.id} className="admin-list-item">
                        <img src={item.resimler ? item.resimler[0] : item.resim_url} alt={item.baslik || item.proje_adi} />
                        <div className="item-info">
                          {item.kategori && <span style={{fontSize: '10px', color: '#ea580c', fontWeight: 'bold'}}>{item.kategori}</span>}
                          <h4>{item.baslik || item.proje_adi}</h4>
                          <button className="delete-btn" onClick={() => handleSil(activeTab, item.id, item.resimler || [item.resim_url])}>SİL</button>
                        </div>
                      </div>
                    ))}
                  </div>

                  {toplamSayfa > 1 && (
                    <div className="pagination-container" style={{marginTop: '30px', paddingBottom: '10px'}}>
                      <button onClick={() => setSilmeSayfasi(prev => prev - 1)} disabled={silmeSayfasi === 1} className="page-btn nav-btn">&#10094; Önceki</button>
                      
                      {/* AKILLI SAYFALAMA BASIMI */}
                      {getSayfaNumaralari(silmeSayfasi, toplamSayfa).map((sayfa, index) => (
                        <button 
                          key={index} 
                          onClick={() => typeof sayfa === 'number' ? setSilmeSayfasi(sayfa) : null} 
                          className={`page-btn ${silmeSayfasi === sayfa ? 'active' : ''}`}
                          disabled={sayfa === '...'}
                          style={sayfa === '...' ? { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'default', boxShadow: 'none' } : {}}
                        >
                          {sayfa}
                        </button>
                      ))}
                      
                      <button onClick={() => setSilmeSayfasi(prev => prev + 1)} disabled={silmeSayfasi === toplamSayfa} className="page-btn nav-btn">Sonraki &#10095;</button>
                    </div>
                  )}
                </>
              )}
            </div>
          )}

          {activeTab === 'kameralar' && altSekme === 'ekle' && (
            <div className="form-section">
              <form onSubmit={handleKameraEkle} style={{display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '600px'}}>
                <input type="text" placeholder="Başlık" value={kameraBaslik} onChange={(e) => setKameraBaslik(e.target.value)} className="admin-form-input" />
                <textarea placeholder="Açıklama" value={kameraAciklama} onChange={(e) => setKameraAciklama(e.target.value)} className="admin-form-input admin-form-textarea" />
                <textarea placeholder="Özellikler (Virgülle ayırın)" value={kameraOzellikler} onChange={(e) => setKameraOzellikler(e.target.value)} className="admin-form-input admin-form-textarea" />
                <label className="custom-file-upload">
                  <div className="upload-icon">📷</div>
                  {kameraResimleri.length > 0 ? <span style={{color: '#ea580c'}}>{kameraResimleri.length} Görsel Seçildi</span> : <span>Görselleri Seç</span>}
                  <input type="file" accept="image/*" multiple onChange={(e) => setKameraResimleri(Array.from(e.target.files))} style={{display: 'none'}} />
                </label>
                <button type="submit" disabled={uploading} className="admin-btn">{uploading ? 'Yükleniyor...' : 'Ekle 🚀'}</button>
              </form>
            </div>
          )}

          {activeTab === 'urunler' && altSekme === 'ekle' && (
            <div className="form-section">
              <form onSubmit={handleUrunEkle} style={{display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '600px'}}>
                <select value={urunKategori} onChange={(e) => setUrunKategori(e.target.value)} className="admin-form-input" style={{color: '#ea580c', fontWeight: 'bold'}}>
                  <option value="Güvenlik Fileleri">Güvenlik Fileleri</option>
                  <option value="İş Güvenliği Ekipmanları">İş Güvenliği Ekipmanları</option>
                  <option value="Zayıf Akım Sistemleri">Zayıf Akım Sistemleri</option>
                </select>
                <input type="text" placeholder="Ürün Başlığı" value={urunBaslik} onChange={(e) => setUrunBaslik(e.target.value)} className="admin-form-input" />
                <textarea placeholder="Açıklama" value={urunAciklama} onChange={(e) => setUrunAciklama(e.target.value)} className="admin-form-input admin-form-textarea" />
                <textarea placeholder="Özellikler (Virgülle ayırın)" value={urunOzellikler} onChange={(e) => setUrunOzellikler(e.target.value)} className="admin-form-input admin-form-textarea" />
                <label className="custom-file-upload">
                  <div className="upload-icon">📦</div>
                  {urunResimleri.length > 0 ? <span style={{color: '#ea580c'}}>{urunResimleri.length} Görsel Seçildi</span> : <span>Görselleri Seç</span>}
                  <input type="file" accept="image/*" multiple onChange={(e) => setUrunResimleri(Array.from(e.target.files))} style={{display: 'none'}} />
                </label>
                <button type="submit" disabled={uploading} className="admin-btn">{uploading ? 'Yükleniyor...' : 'Ekle 🚀'}</button>
              </form>
            </div>
          )}

          {activeTab === 'projeler' && altSekme === 'ekle' && (
            <div className="form-section">
              <form onSubmit={handleProjeEkle} style={{display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '500px'}}>
                <input type="text" placeholder="Projenin Adı" value={projeAdi} onChange={(e) => setProjeAdi(e.target.value)} className="admin-form-input" />
                <label className="custom-file-upload">
                  <div className="upload-icon">📸</div>
                  {resimDosyalari.length > 0 ? <span style={{color: '#ea580c'}}>{resimDosyalari.length} Görsel Seçildi</span> : <span>Görselleri Seç</span>}
                  <input type="file" accept="image/*" multiple onChange={(e) => setResimDosyalari(Array.from(e.target.files))} style={{display: 'none'}} />
                </label>
                <button type="submit" disabled={uploading} className="admin-btn">{uploading ? 'Yükleniyor...' : 'Ekle 🚀'}</button>
              </form>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

export default Admin;